export default __webpack_public_path__ + "static/media/loader.151f7f7a.gif";